function columnSync(){
    var checkOnPersonalPage = document.querySelector('.compare-col-left');
    if (checkOnPersonalPage) {
        var columnCells = (document.querySelectorAll('.compare-col-left > .core-container > .cmp-container').length)-1;
        if(window.innerWidth >= 1024){
            for (i = 1; i < columnCells; i++){
                if(document.querySelectorAll('.compare-col-left > .core-container > .cmp-container')[i].offsetHeight <= document.querySelectorAll('.compare-col-right > .core-container > .cmp-container')[i].offsetHeight){
                    document.querySelectorAll('.compare-col-left > .core-container > .cmp-container')[i].style.height = (document.querySelectorAll('.compare-col-right > .core-container > .cmp-container')[i].offsetHeight+'px');
                }else{
                    document.querySelectorAll('.compare-col-right > .core-container > .cmp-container')[i].style.height = (document.querySelectorAll('.compare-col-left > .core-container > .cmp-container')[i].offsetHeight+'px');
                }
            };
        }else{
            for (i = 0; i < columnCells; i++){
                document.querySelectorAll('.compare-col-left .core-container > .cmp-container')[i].style.height = "auto";
                document.querySelectorAll('.compare-col-right .core-container > .cmp-container')[i].style.height = "auto";
            };
        }
    }
}
window.addEventListener("resize", columnSync);
columnSync();